import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询承诺书审核
export const getCommitmentInfo = params => {
    return reqGet("get", "/app-yijiu-backstage/getCommitmentInfo", params);
};

// 删除承诺书审核
export const deleteCommitment = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteCommitment", params);
};

  // 增加承诺书审核
export const addCommitment = params => {
    return req("post", "/app-yijiu-backstage/addCommitment", params);
};

  // 修改承诺书审核
  export const updateCommitment = params => {
    return req("post", "/app-yijiu-backstage/updateCommitment", params);
};


// WEBPACK FOOTER //
// ./src/api/manage/commitment.js